import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";
import REInfoOldContractBloc from "../../blocs/retirement/info-perso/REInfoOldContractBloc";


export default function REInfoOldContractPage() {
    
    const pageGapRef = useRef<null | HTMLDivElement>(null);
    useEffect(() => {
      if (isMobile()) {
        pageGapRef.current?.scrollIntoView() 
      } else {
        scroll2Top();
      }
    }, []);

    
    return (
      <div className="entreprise-container">
        <h1 className="title ml-lg-desktop mb-sm fw-medium">Résiliation de votre mutuelle</h1>
        <p className="text ml-lg-desktop mt-sm" style={{textAlign: 'justify'}}></p>
        <div ref={pageGapRef} className="page-gap" />
        <div className="m-lg-desktop">
           <REInfoOldContractBloc />
        </div>
      </div>
    )

}